import React from 'react'

interface GlobalModalContextValue {
  showModal: (modal: React.ReactNode) => void
  hideModal: () => void
  isModalVisible: boolean
}

const internalContext = React.createContext<GlobalModalContextValue>({
  showModal: (): void => { },
  hideModal: (): void => { },
  isModalVisible: false
})

internalContext.displayName = "SecurSpaceGlobalModalContext"

export const GlobalModalContext = internalContext
